import { Flex, Image } from "@jewlr/storybook/core"

const MerchantLoading = () => {
  return (
    <Flex justifyContent="center" my="150px">
      <Image
        alt="loading"
        data-cy="collection-loading-icon"
        height="150px"
        src={require("images/layout/loadinglarge.gif")}
        width="150px"
      />
    </Flex>
  )
}

export default MerchantLoading
